import {Routes} from '@angular/router';

const loveProfileComponent = () => import('../components/love-profile/love-profile-v2.component').then(m => m.LoveProfileV2Component)
const loveProfileResultComponent = () => import('../components/love-profile/love-profile-result/love-profile-result.component').then(m => m.LoveProfileResultComponent)
const loveProfileMatchesComponent = () => import('../components/love-profile/love-profile-matches/love-profile-matches.component').then(m => m.LoveProfileMatchesComponent)
const loveProfileResultPretenderComponent = () => import('../components/love-profile/love-profile-result-pretender/love-profile-result-pretender.component').then(m => m.LoveProfileResultPretenderComponent)
const loveProfileUnsubscribe = () => import('../components/love-profile/love-profil-unsubscribe/love-profile-unsubscribe.component').then(m => m.LoveProfileUnsubscribeComponent)

export const loveProfileRoutes: Routes = [
  { path: 'love-profile/result', loadComponent: loveProfileResultComponent},
  { path: 'love-profile/result/pretender', loadComponent: loveProfileResultPretenderComponent},
  { path: 'love-profile/matches', loadComponent: loveProfileMatchesComponent},
  { path: 'love-profile/matches/unsubscribe/:userId', loadComponent: loveProfileUnsubscribe},
  {
    path: 'love-profile',
    loadComponent: loveProfileComponent,
    loadChildren: () => import('./love-profile-form-v2.routes').then(m => m.loveProfileFormRoutes),
    data: {
      seo: {
        title: "Speed dating par affinités : faites la rencontre de célibataires avec un profil compatible au vôtre à Nantes",
        description: "Speed dating par affinités : faites la rencontre de célibataires avec un profil compatible au vôtre à Nantes",
        url: "love-profile/nantes/who"
      }
    }
  },
]
